export default __webpack_public_path__ + "static/media/Plus.2b86033b.svg";